import { render, staticRenderFns } from "./quality_work_edit.vue?vue&type=template&id=2a04b668&scoped=true"
import script from "./quality_work_edit.vue?vue&type=script&lang=js"
export * from "./quality_work_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a04b668",
  null
  
)

export default component.exports